module.exports = __webpack_public_path__ + "static/media/1pic.49709026.png";